import axios from 'axios';
import Cookies from 'js-cookie';
import { COOKIE_NAMES, FILE_API_ENDPOINT } from '../constants';
import { AxiosUtil } from '../utils/axios';

const http = axios.create({
  baseURL: FILE_API_ENDPOINT,
});
const accessToken = Cookies.get(COOKIE_NAMES.COOKIE_ACCESS_TOKEN);
if (!http.defaults.headers['Authorization'] && accessToken) {
  http.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
}
AxiosUtil.handleAutoRefreshToken(http);
http.interceptors.response.use((response: { data: any }) => response.data);

export default http;
